<script setup lang="ts">
const init3 = useInited('init3')
</script>

<template>
  <div :class="$style.m" class="_noline">
    <span :class="$style.txt">MADE IN EUROPE</span>
    <span class="_svg24"><LazyIconMadeInEuStart v-if="init3" class="_svg24" /></span>
  </div>
</template>

<style module>
.m {
  composes: global(_ff1);
  composes: global(_c0);
  composes: global(_fw-xl);
  composes: global(_br9);
  composes: global(_row);
  composes: global(_ctry);
  composes: global(_ctry);
  composes: global(_wmax);
  composes: global(_gap04);
  composes: global(_fs09);
  composes: global(_ls-xs);

  background: #002b8a;
  padding: 1px 4px 1px 10px;
}
.txt {
  margin-bottom: 1px;
}

.m svg {
  vertical-align: middle;
}
</style>
